export const IsWebApp = false;
export const IOSVersion =  1;
export const AndoridVersion =1;